// Modelo de datos para Rol
export class Categorias {
  constructor(data = {}) {
    console.log('🔍 categoria constructor - data recibido:', data);
    console.log('🔍 categoria constructor - keys disponibles:', Object.keys(data));
    
    // ✅ MAPEO CORRECTO PARA TU API (minúsculas primero)
    this.Id_categoria = data.id_categoria || data.Id_categoria || 0;    
    this.Nombre_categoria = data.nombre_categoria || data.Nombre_categoria || '';    
    this.Estado = data.estado || data.Estado || 'ACTIVO';
    this.Id_sucursal = data.id_sucursal || data.Id_sucursal || 0;
    this.Nombre_empresa = data.Nombre_empresa || data.Nombre_empresa || '';  
    this.Nombre_sucursal = data.nombre_sucursal || data.Nombre_sucursal || '';  
    
    console.log('🔍 categoria constructor - objeto creado:', {
      Id_categoria: this.Id_categoria,
      Nombre_categoria: this.Nombre_categoria,
      Estado: this.Estado,
      Id_sucursal: this.Id_sucursal,
      Nombre_empresa: this.Nombre_empresa,
      Nombre_sucursal: this.Nombre_sucursal
    });
    
    if (data instanceof Categorias) {
    this.Id_categoria = data.Id_categoria;
    this.Nombre_categoria = data.Nombre_categoria;
    this.Estado = data.Estado;
    this.Id_sucursal = data.Id_sucursal;
    this.Nombre_empresa = data.Nombre_empresa;
    this.Nombre_sucursal = data.Nombre_sucursal;
  } else {
    // Mapeo normal para datos de API
    this.Id_categoria = data.id_categoria ?? data.Id_categoria ?? null;
    this.Nombre_categoria = data.nombre_categoria ?? data.Nombre_categoria ?? '';
    this.Estado = data.estado ?? data.Estado ?? 'ACTIVO';
    this.Id_sucursal = data.id_sucursal ?? data.Id_sucursal ?? null;
    this.Nombre_empresa = data.nombre_empresa ?? data.Nombre_empresa ?? '';
    this.Nombre_sucursal = data.nombre_sucursal ?? data.Nombre_sucursal ?? '';

  }
    // ✅ VALIDAR QUE SE MAPEARON CORRECTAMENTE
    if (this.Id_categoria === null) {
      console.warn('⚠️ ADVERTENCIA: Id_categoria no se pudo mapear. Data original:', data);
    }
    if (!this.Nombre_categoria) {
      console.warn('⚠️ ADVERTENCIA: Nombre_categoria no se pudo mapear. Data original:', data);
    }
  }

  // Validaciones
  isValid() {
    return this.Nombre_categoria.trim() !== '';
  }

  // ✅ MÉTODO PARA PUT/POST - AJÚSTALO SEGÚN EL FORMATO QUE ESPERA TU API
  toApiFormat() {
    return {
      id_categoria: this.Id_categoria,
      nombre_categoria: this.Nombre_categoria,
      estado: this.Estado,
      id_sucursal: this.Id_sucursal,
      nombre_empresa: this.Nombre_empresa,
      nombre_sucursal: this.Nombre_sucursal
    };
  }

toCreateFormat() {
  return {
    nombre_categoria: this.Nombre_categoria,
    estado: this.Estado,
    id_sucursal: this.Id_sucursal,
    nombre_empresa: this.Nombre_empresa,
    nombre_sucursal: this.Nombre_sucursal
  };
}

  // ✅ MÉTODO PARA DEBUG MEJORADO
  toDebug() {
    return {
      'Frontend (mayúsculas)': {
        Id_categoria: this.Id_categoria,
        Nombre_categoria: this.Nombre_categoria,
        Estado: this.Estado,
        Id_sucursal: this.Id_sucursal,
        Nombre_empresa: this.Nombre_empresa,
        Nombre_sucursal: this.Nombre_sucursal
      },
      'API Format (minúsculas)': this.toApiFormat(true),
      'Is Valid': this.isValid()
    };
  }
}